import React from 'react'

const EventInfo = (props) => {
    const { homeTeamName, awayTeamName, homeOdd, awayOdd, goalOdd, oddChange, isMobile = false } = props;
    return (
        <div className={`flex flex-col ${isMobile ? 'w-full' : 'w-[45%] max-w-[45%]'}  border border-gray-600 py-2 rounded ${oddChange ? 'bg-yellow-200' : 'dark:bg-custom_dark_primary2'}`}>
            <div className="flex flex-row w-full justify-between items-center mt-1">
                <div className={`flex-wrap w-[48%] max-w-[48%] text-center text-sm text-customFontVoilet dark:text-customOrange ${oddChange ? 'font-semibold' : 'font-normal'}`}>
                    {homeTeamName}
                </div>
                <div className={`justify-center bg-blue dark:bg-customDarkGreen text-center text-white rounded px-2 ${isMobile ? 'text-xs' : 'text-sm'}`}>
                    Vs
                </div>
                <div className={`flex-wrap w-[48%] max-w-[48%] text-center text-sm text-customFontVoilet dark:text-customOrange ${oddChange ? 'font-semibold' : 'font-normal'}`}>
                    {awayTeamName}
                </div>
            </div>
            <div className="flex flex-row w-full justify-between items-center">
                <div className="flex-wrap w-[48%] max-w-[48%] text-center">
                    {homeOdd === "null" || homeOdd === null ? null : <span className={`bg-gray-800 px-1 rounded text-white ${isMobile ? 'text-xs' : 'text-sm'}`}>{homeOdd}</span>}
                </div>
                <div className={`justify-center bg-gray-800 text-center w-[15%] max-w-[17%] sm:w-[19%]  text-white rounded px-2 ${isMobile ? 'text-xs' : 'text-sm'}`}>
                    {goalOdd}
                </div>
                <div className="flex-wrap w-[48%] max-w-[48%] text-center">
                    {awayOdd === "null" || awayOdd === null ? null : <span className={`bg-gray-800 px-1 rounded text-white ${isMobile ? 'text-xs' : 'text-sm'}`}>{awayOdd}</span>}
                </div>
            </div>
        </div>
    )
}

export default EventInfo